import { StringSchema } from 'yup';

/* eslint func-names: 0 */

export function phone(this: StringSchema, message?: string): StringSchema {
  return this.test({
    message,
    test(value) {
      if (!value) {
        return false;
      }
      const digitsOnlyValue = value.replace(/\D/g, '');
      if (digitsOnlyValue.startsWith('1')) {
        return false;
      }
      if (digitsOnlyValue.length !== 10) {
        return false;
      }

      return true;
    },
  });
}
